import { Injectable } from '@angular/core';

@Injectable()
export abstract class PinToTaskbarService {

    public async abstract isEligibleToPin(): Promise<boolean>;

    public async abstract pinToTaskbar(): Promise<boolean>;
}